import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { Observable, Subscriber } from 'rxjs';
import { Adjunto } from 'src/app/core/models/pqrs/notify-pqr';

/** Error when invalid control is dirty, touched, or submitted. */

@Component({
    selector: 'app-upload-file',
    templateUrl: './upload-file.component.html',
    styleUrls: ['./upload-file.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: UploadFileComponent,
            multi: true
        }
    ],
    standalone: false
})
export class UploadFileComponent implements OnInit, ControlValueAccessor {

  @Output() attachmentsEvent: EventEmitter<Adjunto> = new EventEmitter();
  @Output() attachmentsEventFormData: EventEmitter<FormData> = new EventEmitter();
  @Output() files: EventEmitter<any> = new EventEmitter();

  @Output() attachmentsEventParent: EventEmitter<string> = new EventEmitter();
  @Input() label: string = "label";
  @Input() maxSizeAttachmentsKb: number = 100;
  @Input() extPermit: string[] = [".jpg", ".png", ".pdf"];
  @Input() isFormData: boolean = false;
  @Input() isSave: boolean = false;
  @Input() required: boolean = false;
  @Input() nameFile;
  @Input() validators: Validators[];
  @Input() disabled = false;
  @Input() nameclassInput: string = "";
  attachments: Adjunto;
  private fileSizeKbAttachments: number = 0;

  @Output() filesPruebas: EventEmitter<any> = new EventEmitter();
  public pruebas = [];

  fileAdjunt: string = "Archivo ";
  form: FormGroup;

  errorFile = false;
  errorFileExt = false;

  @Input() progress;
  onChange: Function;
  onTouch: Function;
  private file: File | null = null;

  @HostListener('change', ['$event.target.files']) change(event: FileList) {
    const file = event && event.item(0);
    this.file = file;
    this.selectFile(file);
  }

  constructor(
    private host: ElementRef<HTMLInputElement>,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit() {
    this.fornInit();

    this.fileAdjunt += this.extPermit.toString().replace(/\./g, " ");
  }

  writeValue(value: any) {
    // clear file input
    this.host.nativeElement.value = value;
    this.file = value;
    this.attachments = value;
  }

  registerOnChange(fn: Function) {
    this.onChange = fn;
  }

  registerOnTouched(fn: Function) {
    this.onTouch = fn;
  }

  fornInit(): void {
    this.form = this.formBuilder.group({
      attachment: [{ value: "", disabled: this.disabled }, this.validators]
    })
  };

  validExtFile(ext: string): boolean {
    let isValid = false;
    this.extPermit.forEach(val => {
      if (ext === val) {
        isValid = true;
      }
    });
    return isValid;
  }

  selectFile(file: File) {
    if (!file) {
      this.onChange(file);
      this.onTouch(file);
      return
    }
    this.errorFileExt = false;
    const archivo = file.name;
    const extension = (archivo.substring(archivo.lastIndexOf("."))).toLowerCase();
    if (!this.validExtFile(extension) && !this.disabled) {
      this.errorFileExt = true;
      return false;
    } else {
      const fileSizeKb = parseInt((file.size / 1024).toString());
      if ((fileSizeKb + this.fileSizeKbAttachments) <= this.maxSizeAttachmentsKb) {
        this.fileSizeKbAttachments = fileSizeKb;
        this.errorFile = false;

        const nameFile = this.nameFile ? `${this.nameFile}${extension}` : file.name;
        file['nameFile'] = nameFile;

        if (this.isFormData) {
          const formData = new FormData();
          formData.set('file', file, nameFile);
          this.onChange(formData);
          this.onTouch(formData);
          this.attachmentsEventFormData.emit(formData);
          this.files.emit(file);
          this.attachmentsEventParent.emit(this.nameclassInput);
        } else {
          this.convertFileToUnit8(file).subscribe(res => {
            const adj: any = {};
            adj.nombre = nameFile;
            adj.contenido = res;
            adj.size = fileSizeKb;
            this.attachments = adj;
            this.onChange(this.attachments);
            this.onTouch(this.attachments);
            this.onChange(file);
            this.onTouch(file);
            this.files.emit(file);
            this.attachmentsEventParent.emit(this.nameclassInput);
          });
        }
      } else {
        this.errorFile = true;
        return false;
      }
    }
  }

  deleteFile(attachments) {
    this.attachments = undefined;
    this.onChange(null);
    this.onTouch(null);
    this.form.get('attachment').reset();
    this.attachmentsEvent.emit(attachments);
  }

  changeO() {

  }

  convertFileToUnit8(file: File): Observable<string> {
    return new Observable(
      (sub: Subscriber<string>): void => {
        const fileReader = new FileReader();
        fileReader.onloadend = function (x) {
          const buffer = fileReader.result as ArrayBuffer;
          const bindaryDataArray = new Uint8Array(buffer);
          sub.next(bindaryDataArray.toString());
        }
        fileReader.onerror = function (x) {
          sub.error(x);
        };
        fileReader.readAsArrayBuffer(file);
      }
    );
  }
}
